export default __webpack_public_path__ + "static/media/VT-800.79ab2134.pdf";